<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- SESSION-meet-ux-004i / SIDEBAR-001 (AC-11): the sidebar now renders through
     the canonical DS <app-app-shell> organism instead of <fuse-vertical-navigation>.
     This removes the Fuse renderer from the chain entirely — the sidebar composes
     strictly from tokens → base → atoms → molecules → organisms (CLAUDE.md hard
     rule 9), so there are no Fuse-internal styles left to override.
     • activeNav is derived from the router URL via `activeNavId` (exact-match
       dict + prefix fallbacks) per AC-10 / PD-2 — manual matching, no
       routerLinkActive prefix double-highlight.
     • role is the resolved persona; <app-app-shell> reacts to switches via its
       `role` setter and owns the persona block (name / pill / footer) itself.
     The page body (topbar + .page content rendered by each routed component)
     projects into <app-app-shell>'s <ng-content> slot. -->
<app-app-shell [activeNav]="activeNavId" [role]="currentRole">
    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>
</app-app-shell>

<!-- Canonical floating theme toggle (GAP-MEETUX-004b) — renders on every role
     shell. PD-3: this floating widget is the ONLY theme switcher in the app
     (the in-sidebar 🎨 Theme button was removed from <app-app-shell>). Markup is
     verbatim from the /home smoke-test page; styled by .theme-toggle in
     organisms.css (position: fixed; bottom-right).
     SESSION-webplanner-004 / GAP-WEBPLANNER-004 — gated behind `showThemeToggle`
     (currently false per Prashant). Theme infrastructure stays live (CLAUDE.md
     hard rule 8); only the UI is hidden. Flip `showThemeToggle = true` in
     futuristic.component.ts to surface it again. -->
<div class="theme-toggle" *ngIf="showThemeToggle">
    <button class="theme-toggle-btn" [class.active]="currentTheme === 'safe'" (click)="setTheme('safe')">Safe</button>
    <button class="theme-toggle-btn" [class.active]="currentTheme === 'bold'" (click)="setTheme('bold')">Bold</button>
</div>
